module.exports = __webpack_public_path__ + "img/d11.4fd6fc40.jpg";